import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Alert, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { authFetch } from "../utils/authFetch";
import { NirForm } from "../nir/Form";
import ViewNotaModal from "../ViewNotaModal";

export default function ProcesVerbalEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [showNota, setShowNota] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data = await authFetch(`/proces-verbal/${id}`);
        setForm(data);
      } catch (e) {
        setError(String(e.message || e));
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await authFetch(`/proces-verbal/${id}`, {
        method: "PUT",
        body: JSON.stringify(form),
      });
      toast.success("Procesul verbal a fost salvat cu succes!");
      navigate("/proces-verbal");
    } catch (e) {
      setError(String(e.message || e));
      toast.error(`Eroare la salvare: ${e.message || e}`);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Container className="py-3">Se încarcă…</Container>;
  if (!form)
    return (
      <Container className="py-3 text-danger">
        Nu s-a găsit înregistrarea.
      </Container>
    );

  return (
    <Container className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Editează Proces verbal #{id}</h3>
        <div className="d-flex gap-2">
          <Button
            variant="outline-secondary"
            onClick={() => navigate("/proces-verbal")}
          >
            ← Înapoi
          </Button>
          <Button
            variant="outline-info"
            onClick={() => window.open(`/proces-verbal/${id}/print`, "_blank")}
          >
            Print
          </Button>
          <Button variant="outline-secondary" onClick={() => setShowNota(true)}>
            Vezi nota
          </Button>
        </div>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      <NirForm
        value={form}
        onChange={setForm}
        onSubmit={save}
        submitting={saving}
      />

      <ViewNotaModal
        recType={2} // <-- IMPORTANT: pune rec_type-ul pe care îl folosești pentru PV
        docId={Number(id)}
        show={showNota}
        onHide={() => setShowNota(false)}
      />
    </Container>
  );
}
